export default function (state = [], action) {
  switch (action.type) {
    case "GET_QUERISTS":
      return action.payload;
      break;
    default:
      return state;
  }
}
